<template>
  <app-tenant-resource-log-modal
      :row-data="rowData"
  />
</template>

<script>

export default {
  name: "TenantResourceButton",
  // components: {LeaveLogContent,LeaveLogNote},
  // mixins: [ModalMixin, FormHelperMixins],
  props: {
    value: {},
    rowData: {},
    tableId: {}
  },
  data() {
    return {
      isResponseLogModalActive: false,
    }
  },
  mounted() {
  },
  computed: {},
  methods: {
    openResourceModal(){
      let action = {name: 'tenant-resource-log'}
      this.$hub.$emit('getTenantAction', this.rowData, action, true)
    }
  },
}
</script>